// Vuetify semantic color names, for use with components' `color`/`text-color` props.
export const CONTRACT_STATUS_COLORS = {
  "VAŽI": "success",
  "USKORO ISTIČE": "warning",
  "ISTEKAO": "error",
  "BEZ ROKA": "success",
};

// The actual hex behind those Vuetify colors (this app overrides "error" in
// src/plugins/vuetify.js; "success"/"warning" are Vuetify's defaults). Only
// needed where a raw CSS color is required (inline styles, box-shadows) and a
// component `color` prop isn't an option.
const CONTRACT_STATUS_HEX = {
  "VAŽI": "#4CAF50",
  "USKORO ISTIČE": "#FB8C00",
  "ISTEKAO": "#b71c1c",
  "BEZ ROKA": "#4CAF50",
};

// The backend sometimes sends status values without diacritics
// (e.g. "VAZI" instead of "VAŽI"); normalize before matching so both forms work.
const STATUS_ALIASES = {
  VAZI: "VAŽI",
  "USKORO ISTICE": "USKORO ISTIČE",
};

export function normalizeContractStatus(status) {
  return STATUS_ALIASES[status] || status;
}

export function contractStatusColor(status) {
  return CONTRACT_STATUS_COLORS[normalizeContractStatus(status)] || "grey";
}

export function contractStatusHex(status) {
  return CONTRACT_STATUS_HEX[normalizeContractStatus(status)] || "#9e9e9e";
}

export function isHealthyContractStatus(status) {
  const normalized = normalizeContractStatus(status);
  return normalized === "VAŽI" || normalized === "BEZ ROKA";
}

export function contractStatusLabel(contract, t) {
  const status = normalizeContractStatus(contract.status);
  if (status === "USKORO ISTIČE" && contract.dana_do_isteka != null) {
    return t("contract_expires_in_days", { count: contract.dana_do_isteka });
  }
  if (status === "ISTEKAO" && contract.dana_do_isteka != null) {
    return t("contract_expired_days_ago", { count: Math.abs(contract.dana_do_isteka) });
  }
  if (status === "BEZ ROKA") return t("contract_status_no_deadline");
  return t("contract_status_active");
}
